var utils = require("../../utils/utils");

var uiFactory = function createFactory(gantt){
	var views = {
		"layout": require("./layout/layout"),
		"multiview": require("./layout/view_layout"),
		"viewcell": require("./layout/view_cell"),
		"resizer": require("./layout/resizer_cell"),
		"cell": require("./layout/cell")
	};

	function ui(cell) {
		var content;

		if (cell.view){
			content = createView.call(this, "viewcell", null, cell);
		}else if (cell.resizer) {
			content = createView.call(this, "resizer", null, cell);
		}
		else if (cell.rows || cell.cols) {
			content = createView.call(this, "layout", null, cell);
		}
		else if (cell.views) {
			content = createView.call(this, "multiview", null, cell);
		}
		else {
			content = createView.call(this, "cell", null, cell);
		}
		return content;
	}
	
	var createdViews = {};

	function createView(name, parent, config) {
		var creator = views[name];

		if(!creator || !creator.create)
			return false;

		var config = utils.copy(config);
		if(config.id && !config.css){
			config.css = config.id+"_cell";
		}

		var view = new creator.create(parent, config, this, gantt);

		if(creator.configure){
			creator.configure(view);
		}

		if(!view.$id){
			view.$id = config.id || gantt.uid();
		}

		if(!view.$parent && typeof parent == "object"){
			view.$parent = parent;
		}
		if(!view.$config){
			view.$config = config;
		}

		if(createdViews[view.$id]){
			view.$id = gantt.uid();
		}

		createdViews[view.$id] = view;

		return view;
	}

	function reset(){
		createdViews = {};
	}

	function register(name, viewConstructor, configure){
		views[name] = {create: viewConstructor, configure: configure};
	}

	function getView(id){
		return createdViews[id];
	}

	var factory = {
		initUI:ui,
		reset: reset,
		registerView: register,
		createView: createView,
		getView: getView
	};

	return factory;
};

module.exports = {
	createFactory: uiFactory
};




//////////////////
// WEBPACK FOOTER
// ./sources/core/ui/ui_factory.js
// module id = 9
// module chunks = 0